const config = ocm && ocm.config;

export const country = (config && config.country) || "de";
export const language = (config && config.language) || "de";
export const contextPath = (config && config.encodedContextPath) || `/${country}-de/shop`;
export const isClassicSite = ocm && ocm.isClassicSite;
export const shopContextPath = isClassicSite ? `/${country}-de/shop` : contextPath;

export const isEpoqRecosPlpEnabled = config && config.isEpoqRecosPlpEnabled;
export const isUserInTestGroupEpoqRecosPlp = config && config.isUserInTestGroupEpoqRecosPlp;
export const epoqRecosPlpChunkSize = config && config.epoqRecosPlpChunkSize;
export const is8SelectRecosPdpEnabled = config && config.is8SelectRecosPdpEnabled;
export const isEpoqRecosPdpEnabled = config && config.isEpoqRecosPdpEnabled;
export const isUserInTestGroupEpoqAddToCartReco = config && config.isUserInTestGroupEpoqAddToCartReco;
